import type { SuccessBoxProps } from '@/components/landing-page/components/success-box/success-box.types';

export const defaults: Required<SuccessBoxProps> = {
  color: '',
  head: { primary: '', secondary: '' },
  body: [],
};
